import { render } from "./outgoing-call.vue?vue&type=template&id=a236154c"
import script from "./outgoing-call.vue?vue&type=script&lang=js"
export * from "./outgoing-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__